import slugify from "slugify";
import Device from "../constants/Device";
import { decode } from "html-entities";
//import crypto from 'crypto';
//const crypto = require('crypto');
import { format, addDays, addMinutes } from "date-fns";
import Browser from "../utils/browser";
import Sites, { _SITEID_REVERSE_MAP_ } from "../constants/Sites";
import Cookies from "js-cookie";
import RouteService from "../services/RouteService";
import Image from "../components/Image/Image";

export const capitalize = (str) => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const stripHtml = (str) => (str ? decode(str.replace(/<[^>]*>/g, "")).trim() : "");
///////////////////////////////////////////////////////////////////////////////
//                     PAGE/COMPONENT RENDERING FUNCTIONS                    //
///////////////////////////////////////////////////////////////////////////////

export const renderFreeVoiceBanner = (width = 100, height = 40) => {
  return (
    <div>
      <a href="https://earlybirdbooks.com/free-voices" target="_blank" rel="noopener noreferrer">
        <Image name={"e6662ba6c372-freevoice.jpg"} width={width} height={height} />
      </a>
    </div>
  );
};
const categoriesWhitelist = () => {
  return ["Future-Present"];
};

export const formatCategory = (category, isSlug) => {
  category = Array.isArray(category) ? category[0] : category;
  const categoryWhitelist = categoriesWhitelist();
  //skip categories in the white list
  if (category && typeof category === "string" && categoryWhitelist.indexOf(category) === -1) {
    if (isSlug) {
      return category?.replace(/ /g, "-").replace("&", "and");
    } else {
      return category?.replace(/-/g, " ").replace("and", "&");
    }
  } else {
    return category;
  }
};

export const renderCategories = (category, categoryRedirect, index) => {
  if (category) {
    return (
      <span
        className={"category " + formatCategory(category).toLowerCase() + "_class"}
        onClick={() => categoryRedirect(category)}
        key={index}
      >
        {formatCategory(category)}
      </span>
    );
  }
};

/* 
  Description : Format date in specified format. Mongo date are stored in UTC. When we use format from date-fns, it will automatically convert dates into local timezone (which in out case is EST). So UTC string like 2021-02-05T00:00:00.000Z can be converted to Feb 1, 2021. To avoid this, we offset the incoming date with current timezone and than apply format
*/
export const _formatDate = (dateString, dateformat) => {
  //Date are in UTC but date-fns format will always convert it to local timezone. So to avoid this, doing offset with local timezone
  const dt = new Date(dateString);
  const dtDateOnly = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
  let newDate = format(dtDateOnly, dateformat);
  return newDate;
};

export const doubleOptinParkingList = () => {
  //Defining parking list name as object for Double Opt-In. When require add other content sites too
  //Catalog site isn't a product in SailThru
  return {
    earlybirdbooks: {
      name: "Early Bird Books - Signup from Content Sites",
      utm_param: "EBBGOAAAAH",
      site_id: 1,
    },
    "the-line-up": {
      name: "The Lineup - Signup from Content Sites",
      utm_param: "EBBGOAAAAJ",
      site_id: 2,
    },
    theportalist: {
      name: "The Portalist - Signup from Content Sites",
      utm_param: "EBBGOAAAAM",
      site_id: 3,
    },
    "murder-mayhem": {
      name: "Murder & Mayhem - Signup from Content Sites",
      utm_param: "EBBGOAAAAL",
      site_id: 7,
    },
    alovesotrue: {
      name: "A Love So True - Signup from Content Sites",
      utm_param: "EBBGOAAAAG",
      site_id: 8,
    },
    explorethearchive: {
      name: "Archive - Signup from Content Sites",
      utm_param: "EBBGOAAAAK",
      site_id: 9,
    },
    openroadmedia: { utm_param: "EBBGOAAAAN" },
    ebbreader: {
      name: "The Reader - Signup from Content Sites",
      utm_param: "EBBGOAAAAH",
    },
  };
};

//get the header background color
export const HeaderBGColor = (siteId) => {
  let headerBGColor = Sites.HEADERBGCOLORS.find((row) => {
    return siteId == row.HEADERBGCOLOR_KEY;
  });
  return headerBGColor.COLOR;
};

//get the header background color
export const HeaderTextColor = (siteId) => {
  let headerTextColor = Sites.HEADERTEXTCOLORS.find((row) => {
    return siteId == row.HEADERTEXTCOLOR_KEY;
  });
  return headerTextColor.COLOR;
};

// export const includeAmpAnalyticScript = (gaTrackingId) => {
// 	return {
// 		__html: `
//     {
//       "vars" : {
//         "gtag_id": "${gaTrackingId}",
//         "config" : {
//           "${gaTrackingId}": { "groups": "default" }
//         }
//       }
//     }`
//   }
// }

export const PostTypes = (postType) => {
  if (postType) {
    switch (postType) {
      case 1:
        return "Homepage";
      case 2:
        return "Listicle";
      case 3:
        return "Book_Listicle";
      case 4:
        return "Long_Form";
      case 5:
        return "Interview";
      case 6:
        return "Sideshow";
      case 7:
        return "Video";
      case 8:
        return "Book_Excerpt";
      case 9:
        return "Page";
      case 10:
        return "General";
      case 11:
        return "Funnel";
      case 12:
        return "Deals";
      case 13:
        return "Landing_Deals";
      case 14:
        return "Category_Funnel";
      case 16:
        return "Giveaway_Page";
    }
  }
};
///////////////////////////////////////////////////////////////////////////////
//                              SCHEMA FUNCTIONS                             //
// Please check Google Required field at https://developers.google.com/search/docs/data-types/book#work-example
///////////////////////////////////////////////////////////////////////////////

//While making any change,
//check required field, type, length at https://developers.google.com/search/docs/data-types/book#definitions
export const RenderBookSchema = (book, bookUrl, host) => {
  const pageCount = book.page_count || 0;

  const allAuthors = (book.authors || []).map((item) => ({
    "@type": "Person",
    name: item.display_name,
    image: item.image,
    url: appendHttpsToUrl(`${host}/contributor/${item.slug}`),
  }));

  const price =
    book.campaigngrid?.length > 0
      ? book.campaigngrid[0].promotedtitles?.[0]?.promoprice || book.price
      : book.price;

  const aggregateRatingList = book.bookdata ? RenderRating(book.bookdata) : [];
  const aggregateRating =
    Array.isArray(aggregateRatingList) && aggregateRatingList.length > 0
      ? aggregateRatingList[0]
      : undefined;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Book",
    "@id": `${appendHttpsToUrl(bookUrl)}#book`,
    name: book.title,
    author: allAuthors,
    url: appendHttpsToUrl(bookUrl),
    description: stripHtml(book.description),
    isbn: book.primary_isbn,
    bookFormat: "https://schema.org/EBook",
    numberOfPages: pageCount,
    datePublished: book.pub_date,
    publisher: book.publisher ? { "@type": "Organization", name: book.publisher } : undefined,
    image: book.image,
    ...(aggregateRating ? { aggregateRating } : {}),
    offers: {
      "@type": "Offer",
      price: price,
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
      url: appendHttpsToUrl(bookUrl),
    },
  };

  return { __html: JSON.stringify(schema) };
};

export const RenderBookListSchema = (books, host) => {
  if (!books?.length) return null;

  return {
    __html: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ItemList",
      numberOfItems: books?.length,
      itemListElement: books.map((book, index) => ({
        "@type": "Book",
        position: index + 1,
        name: book.title,
        url: `${host}${formatBookDetailUrl(book.primary_isbn, book.title)}`,
        ...(book.primary_isbn ? { isbn: book.primary_isbn } : {}),
        ...(book.image ? { image: appendHttpsToUrl(book.image) } : {}),
        ...(book.authors?.length > 0
          ? {
              author: book.authors.map((a) => ({
                "@type": "Person",
                name: a.display_name,
                url: appendHttpsToUrl(`${host}/contributor/${a.slug}`),
              })),
            }
          : {}),
        ...(book.publisher ? { publisher: { "@type": "Organization", name: book.publisher } } : {}),
      })),
    }),
  };
};

export const RenderOrganizationSchema = (publisherName, pageUrl, logo, description, siteName) => {
  if (!publisherName) return null;
  return {
    __html: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: publisherName,
      url: appendHttpsToUrl(pageUrl),
      ...(logo ? { logo: { "@type": "ImageObject", url: logo } } : {}),
      ...(description ? { description } : {}),
      publisher: {
        "@type": "Organization",
        name: siteName || "Open Road Media",
      },
    }),
  };
};

export const RenderRating = (ratingData) => {
  let rating = ratingData.latestRating,
    reviews = ratingData.latestReviews,
    aggregateRating = [];
  if (rating != null && rating != 0 && reviews != null && reviews != 0) {
    aggregateRating.push({
      "@type": "AggregateRating",
      ratingCount: reviews,
      reviewCount: reviews,
      ratingValue: rating,
    });
    return aggregateRating;
  } else {
    return "";
  }
};

//While making any change,
//check required field, type, length at https://developers.google.com/search/docs/data-types/book#definitions
export const RenderPersonSchema = (name, image, url, bio) => {
  return {
    __html: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Person",
      "@id": appendHttpsToUrl(url) + "#person",
      name: name,
      url: appendHttpsToUrl(url),
      description: bio,
      image: image,
    }),
  };
};

export const RenderAuthorSchema = (author, pageUrl, siteName) => {
  if (!author?.display_name) return null;
  return {
    __html: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Person",
      "@id": `${appendHttpsToUrl(pageUrl)}#person`,
      name: author.display_name,
      url: appendHttpsToUrl(pageUrl),
      ...(author.image ? { image: appendHttpsToUrl(author.image) } : {}),
      ...(author.short_bio ? { description: stripHtml(author.short_bio) } : {}),
      jobTitle: "Author",
      worksFor: {
        "@type": "Organization",
        name: siteName || "Open Road Media",
      },
    }),
  };
};

export const RenderCollectionPageSchema = (name, description, pageUrl) => {
  if (!name || !pageUrl) return null;
  name = capitalize(name);
  const url = appendHttpsToUrl(pageUrl);
  return {
    __html: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "@id": `${url}#webpage`,
      url,
      name: name,
      description: description,
      about: {
        "@id": `${url}#person`,
      },
    }),
  };
};

//While making any change,
//check required field, type, length at https://developers.google.com/search/docs/data-types/breadcrumb
export const RenderBreadCrumbSchema = (domain, categoryUrl, contentTitle) => {
  return {
    __html: `{
				"@context": "https://schema.org",
				"@type": "BreadcrumbList",
				"name" : ${JSON.stringify(contentTitle)},
				"itemListElement":[
					{
					  "@type": "ListItem",
					  "position": "1",
					  "item":
					  {
					   "@id": "${domain}",
					   "name": "Home"
					   }
					 },
					 {
					  "@type": "ListItem",
					  "position": "2",
            "item":
              {
                "@id": "${appendHttpsToUrl(categoryUrl)}",
                "name": ${JSON.stringify(contentTitle)}
              }
					 }
				  ]
			}`,
  };
};

//While making any change,
//check required field, type, length at https://developers.google.com/search/docs/data-types/article#non-amp
export const RenderArticleSchema = (post, SiteSettings, host) => {
  const url = `${appendHttpsToUrl(host)}/${post && formatUrl(post.slug, post.redirect)}`;
  const hostUrl = appendHttpsToUrl(host);
  const siteName = SiteSettings?.site_name || "Open Road Media";

  const datePublished = post?.originalpub_date
    ? new Date(post.originalpub_date).toISOString().split("T")[0]
    : null;
  const dateModified = post?.published_on
    ? new Date(post.published_on).toISOString().split("T")[0]
    : null;

  const imageUrl = post?.featured_media?.name
    ? `https://orion-uploads.openroadmedia.com/xl_${post.featured_media.name}`
    : null;

  const firstByline = post?.byline?.length > 0 && post?.byline[0] !== null ? post.byline[0] : null;
  const authorName = firstByline?.display_name || siteName;
  const authorSlug = firstByline?.slug ? `${hostUrl}/contributor/${firstByline.slug}` : null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "@id": `${url}#article`,
    headline: getSubstring(post?.title, 105) || "",
    description: post?.sub_title || "",
    url,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url,
    },
    ...(datePublished ? { datePublished } : {}),
    ...(dateModified ? { dateModified } : {}),
    articleSection: post?.categories?.length ? post.categories[0].trim() : "",
    ...(imageUrl
      ? {
          image: {
            "@type": "ImageObject",
            url: imageUrl,
            width: 600,
            height: 300,
          },
        }
      : {}),
    author: {
      "@type": firstByline ? "Person" : "Organization",
      name: authorName,
      ...(authorSlug ? { url: authorSlug } : {}),
    },
    publisher: {
      "@type": "Organization",
      name: siteName || "Open Road Media",
      logo: {
        "@type": "ImageObject",
        url: SiteSettings?.primary_site_logo || "",
        width: 600,
        height: 60,
      },
    },
    isPartOf: {
      "@type": "WebSite",
      "@id": `${hostUrl}/#website`,
    },
  };

  return { __html: JSON.stringify(schema) };
};

export const RenderHomePageSchema = (SiteSettings, post, host, siteId) => {
  host = appendHttpsToUrl(host);

  let sameAs =
    siteId === Sites.OPENROADMEDIA
      ? [
          "https://www.facebook.com/OpenRoadMedia",
          "https://twitter.com/OpenRoadMedia",
          "https://www.instagram.com/openroadmedia",
        ]
      : (SiteSettings.site_footer &&
          SiteSettings.site_footer.social_media &&
          Object.keys(SiteSettings.site_footer.social_media).map(
            (social) => SiteSettings.site_footer.social_media[social]
          )) ||
        [];

  const siteName = post?.seo?.title || "Open Road Media Catalog";
  const orgName = SiteSettings?.site_name || "Open Road Media";
  const logo = SiteSettings?.primary_site_logo || "";
  const description = post?.seo?.description || "";

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        name: siteName,
        url: host,
        description,
        image: logo,
        publisher: {
          "@type": "Organization",
          name: orgName,
          logo: {
            "@type": "ImageObject",
            url: logo,
          },
        },
        potentialAction: {
          "@type": "SearchAction",
          target: {
            "@type": "EntryPoint",
            urlTemplate: `${host}/search/{search_term_string}`,
          },
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "Organization",
        name: orgName,
        url: host,
        logo,
        sameAs,
      },
    ],
  };

  return { __html: JSON.stringify(schema, null, 2) };
};

export const renderFunnelPageSchema = (post, SiteSettings, domain) => {
  let url = post && formatUrl(post.slug, post.redirect);
  let socialMedia =
    SiteSettings.site_footer &&
    SiteSettings.site_footer.social_media &&
    Object.keys(SiteSettings.site_footer.social_media).map((social) => {
      return SiteSettings.site_footer.social_media[social];
    });
  let publishedOn = post.originalpub_date,
    updatedOn = post.published_on,
    modifiedDate =
      publishedOn === null || new Date(updatedOn).getTime() <= new Date(publishedOn).getTime()
        ? publishedOn
        : updatedOn;
  if (modifiedDate) modifiedDate = new Date(modifiedDate).toISOString();
  const jsonObject = {
    "@context": "https://schema.org/",
    "@type": "Article",
    headline: post.title && post.title.replace(/<(?:.|\n)*?>/gm, ""),
    name: post.title && post.title.replace(/<(?:.|\n)*?>/gm, ""),
    description: post.sub_title && post.sub_title.replace(/<(?:.|\n)*?>/gm, ""),
    datePublished: post.originalpub_date && new Date(post.originalpub_date).toISOString(),
    dateModified: post.published_on && modifiedDate,
    articleSection: post.categories && post.categories.length ? post.categories[0].trim() : "",
    url: appendHttpsToUrl(domain + "/" + url),
    sameAs: socialMedia,
    image:
      post.featured_media && post.featured_media.name
        ? appendHttpsToUrl(
            formatImageUrlByDevice(
              post.featured_media.name,
              this.props.Device_Size,
              this.props.size
            )
          )
        : "https://orion-uploads.openroadmedia.com",
    author: {
      "@type": "Person",
      name:
        post.byline && post.byline.length > 0 && post.byline[0] !== null
          ? post.byline.map((byline) => byline.display_name).join(", ")
          : "Open Road Media",
    },
    publisher: {
      "@type": "Organization",
      name: post.Promoted ? post.Promoted : "Open Road Media",
      logo: {
        "@type": "ImageObject",
        url: SiteSettings.primary_site_logo,
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      name: post.promoted ? post.promoted : "Open Road Media",
      "@id": appendHttpsToUrl(domain + "/" + url),
    },
  };
  return {
    __html: JSON.stringify(jsonObject),
  };
};

///////////////////////////////////////////////////////////////////////////////
//                              IMAGE FUNCTIONS                              //
///////////////////////////////////////////////////////////////////////////////
/* 
image should be url like https://book-assets.openroadmedia.com/9781614754770.jpg
we will pop just the image name always and use it with different cloudfront which is created by serverless-image-handler. Client will pass require width & height value.
*/
export const BuildServerlessBookCoverImageUrl = ({ width, height }, imageName) => {
  //If for any reason, serverless image handler is disabled than use regular cloudfront URL
  if (process.env.REACT_APP_ENABLE_SLS_IMAGEHANDLER === "false") return imageName;
  if (imageName && typeof imageName === "string") {
    //Internal book cover is full url like https://book-assets.openroadmedia.com/9781614754770.jpg, we only need name which is lastSegment
    const lastSegment = imageName?.split("/").pop();
    if (process.env.REACT_APP_ENABLE_SLS_IMAGEHANDLER === "true" && width)
      return `${process.env.REACT_APP_SLS_IMAGE_CLDFRONT}/${width}x${height}/${lastSegment}`;
    else return `${process.env.REACT_APP_SLS_IMAGE_CLDFRONT}/${lastSegment}`;
  }

  return `${process.env.REACT_APP_SLS_IMAGE_CLDFRONT}/defaultbookcover.jpg`;
};

//E.L should be phased out by formatImageUrlByDevice
export const formatImageUrl = (name, size) => {
  let cdn = "https://orion-uploads.openroadmedia.com/";
  if (name && size) {
    switch (size.toLowerCase()) {
      case "xl":
        return cdn + "xl_" + name;
      case "lg":
        return cdn + "lg_" + name;
      case "md":
        return cdn + "md_" + name;
      case "sm":
        return cdn + "sm_" + name;
      default:
        throw "Size not found!";
    }
  }
};

export const formatImageUrlByDevice = (name, device_size, size, useLGImage = false) => {
  //Following has been added as part of https://openroadmedia.atlassian.net/browse/ORMTECH-1680, we need to display lg_ version of image for EBB Homepage and any cloned EBB Homepage
  if (useLGImage) return `https://orion-uploads.openroadmedia.com/lg_${name}`;

  let prefix = Device[device_size] ? Device[device_size].IMAGE_PREFIX : "md";

  if (size) {
    prefix =
      Device[size] >= Device[device_size]
        ? Device[device_size].IMAGE_PREFIX
        : Device[size].IMAGE_PREFIX;
  }
  return `https://orion-uploads.openroadmedia.com/${prefix}_${name}`;
};

///////////////////////////////////////////////////////////////////////////////
//                              COOKIE FUNCTIONS                             //
///////////////////////////////////////////////////////////////////////////////
export const setCookie = (name, value, expireInSeconds) => {
  let date;
  const secondsInDay = 86400;
  if (expireInSeconds) {
    date = addDays(new Date(), expireInSeconds / secondsInDay);
  } else {
    date = "";
  }
  Cookies.set(name, value, { path: "/", expires: date });
};

export const readCookie = (cookieKey, req) => {
  if (req && req.headers && req.headers.cookie) {
    // check if theres a token in url (this means it comes from admin)
    const { token } = parseQueryString(req.url);
    if (token) return token;
    // contruct new cookie based on req.headers.cookie and send it back
    else return getCookieFromReq(req, cookieKey);
  }
  // comes from browser/client
  else {
    return Cookies.get(cookieKey);
  }
};

export const newReadCookie = (cookieKey, cookie, url) => {
  if (cookie) {
    // check if theres a token in url (this means it comes from admin)
    const { token } = parseQueryString(url);
    if (token) return token;
    // contruct new cookie based on req.headers.cookie and send it back
    else {
      return cookie.get(cookieKey)?.value || undefined;
    }
  } else {
    return Cookies.get(cookieKey);
  }
};

export const clearCookie = (name) => {
  Cookies.remove(name);
  //Cookies.set(name, value, {path: '/', expires: new Date()})
  // keep this here if we can get cookies.remove to work someday
  // return cookies.remove(name, options);
};

export const getCookieFromReq = (req, cookieKey) => {
  const mycookie =
    req.headers &&
    req.headers.cookie &&
    req.headers.cookie.split(";").find((c) => c.trim().startsWith(`${cookieKey}=`));

  if (!mycookie) {
    return undefined;
  }

  return mycookie.split("=")[1];
};

///////////////////////////////////////////////////////////////////////////////
//                            PAGINATION FUNCTIONS                           //
///////////////////////////////////////////////////////////////////////////////

//use to convert the page number in to Integer and return default value 1 if find null
export const getPageNumberAsInt = (currentPageNumber, totalRecords) => {
  if (currentPageNumber == null) {
    return 1;
  } else if (parseInt(currentPageNumber) > getLastPageNumber(totalRecords)) {
    return currentPageNumber;
  } else if (!isNaN(currentPageNumber)) {
    return parseInt(currentPageNumber);
  }
};

//use to get the last page number of pagination
export const getLastPageNumber = (totalRecords, pageSize) => {
  if (totalRecords) {
    return Math.ceil(totalRecords / pageSize);
  }
};

//use to check the currentpage isfirstpage and return boolean value
export const _isFirstPage = (currentPageNumber) => currentPageNumber == "1";

//use to check the currentpage islastpage and return boolean value
export const _isLastPage = (currentPageNumber, totalRecords, pageSize) => {
  if (totalRecords) {
    return getPageNumberAsInt(currentPageNumber) * pageSize >= totalRecords;
  }
};

// to get the text like 'Showing 41-80 of 7250 eBooks'
export const getPaginationText = (totalRecords, currentPageNumber, pageSize, afterText) => {
  let toLimit = currentPageNumber * pageSize,
    paginationText;
  if (toLimit > totalRecords) {
    toLimit = totalRecords;
  }
  if (totalRecords === pageSize) {
    paginationText = `Showing ${pageSize} of ${totalRecords} ${afterText}`;
  } else {
    paginationText = `Showing ${(currentPageNumber - 1) * pageSize + 1}-${toLimit} of ${totalRecords} ${afterText}`;
  }
  return paginationText;
};

//baselink will pass as AS attribute in the Link tag
export const getBasePageLink = (pageName, slug) => {
  let baseLink;
  if (pageName) {
    baseLink = `/${pageName}/${encodeURIComponent(slug)}?page=`;
  } else {
    baseLink = `/${encodeURIComponent(slug)}?page=`;
  }
  return baseLink;
};

//function to get the previous page link
export const previousLink = (pageName, slug, currentPageNumber) => {
  let previousLink = `${getBasePageLink(pageName, slug)}${currentPageNumber - 1}`;
  return previousLink;
};

//function to get the next page link
export const nextLink = (pageName, slug, currentPageNumber) => {
  let nextLink = `${getBasePageLink(pageName, slug)}${currentPageNumber + 1}`;
  return nextLink;
};

export const getPageNumber = (url) => {
  let pageNumber = 1;
  if (url && url.indexOf("?") > 0) {
    pageNumber = url.replace(/\/$/, "").toString().replace("/", "").split("=").pop();
  }

  if (pageNumber <= 0 || isNaN(pageNumber)) {
    pageNumber = 1; // Because page number can't be boolean value
  }
  return pageNumber;
};

///////////////////////////////////////////////////////////////////////////////
//                          SITE/SETTINGS FUNCTIONS                          //
///////////////////////////////////////////////////////////////////////////////

export const findSiteId = (domain) => {
  if (domain) {
    if (domain.indexOf("earlybirdbooks.com") >= 0) return 1;
    if (domain.indexOf("openroadmedia.com") >= 0) return 6;
    if (domain.indexOf("theportalist.com") >= 0) return 3;
    if (domain.indexOf("the-line-up.com") >= 0) return 2;
    if (domain.indexOf("alovesotrue.com") >= 0) return 8;
    if (domain.indexOf("murder-mayhem.com") >= 0) return 7;
    if (domain.indexOf("explorethearchive.com") >= 0) return 9;
    if (domain.indexOf("localhost") >= 0 && process.env.ORION_ENV === "development") return 1;
  }
};

export const findSiteName = (siteId) => {
  if (siteId) {
    switch (siteId) {
      case 1:
        return "earlybirdbooks.com";
      case 2:
        return "the-line-up.com";
      case 3:
        return "theportalist.com";
      case 6:
        return "openroadmedia.com";
      case 7:
        return "murder-mayhem.com";
      case 8:
        return "alovesotrue.com";
      case 9:
        return "explorethearchive.com";
    }
  }
};
export const getThankYouMessage = (siteId, ldl, email) => {
  if (siteId) {
    switch (siteId) {
      case 1:
        return ldl
          ? `Thank you for submitting your email! Your free ebook downloading instructions will be sent to ${email}`
          : "Book deals are on the way! Check your inbox for a welcome message.";
      case 2:
        return "You're one of us now! Check your inbox for a welcome message";
      case 3:
        return " You just leveled up! Check your inbox for a welcome message";
      case 6:
        return "You're one of us now! Check your inbox for a welcome message";
      case 7:
        return "You just cracked the case, sleuth! Check your inbox for a welcome message";
      case 8:
        return "We're official! Check your inbox for a welcome message";
      case 9:
        return "You're now a part of history! Check your inbox for a welcome message";
    }
  }
};

export const findSiteNameWithoutCom = (siteId) => {
  if (siteId) {
    switch (siteId) {
      case 1:
        return "earlybirdbooks";
      case 2:
        return "the-line-up";
      case 3:
        return "theportalist";
      case 6:
        return "openroadmedia";
      case 7:
        return "murder-mayhem";
      case 8:
        return "alovesotrue";
      case 9:
        return "explorethearchive";
    }
  }
};

// maps sitename to siteid
export const SiteName_SiteID_Map = (siteName) => {
  const sitename_siteid_map = new Map([
    ["earlybirdbooks", Sites.EARLYBIRDBOOKS],
    ["the-line-up", Sites.THE_LINE_UP],
    ["theportalist", Sites.THEPORTALIST],
    ["murder-mayhem", Sites.MURDER_MAYHEM],
    ["explorethearchive", Sites.EXPLORETHEARCHIVE],
    ["alovesotrue", Sites.ALOVESOTRUE],
    ["ebbreader", Sites.NOT_SITE],
  ]);
  return sitename_siteid_map.get(siteName);
};

// Algolia index names, configured per environment. They mirror the indexing cron's ORM_BOOKS_INDEX,
// ORM_AUTHORS_INDEX and ORM_POST_INDEX settings and must point at the same indices. These are build-time
// values, so each must be read as a literal process.env.NEXT_PUBLIC_* reference. The defaults are the
// production index names.
export const ALGOLIA_BOOKS_INDEX = process.env.NEXT_PUBLIC_ORM_BOOKS_INDEX || "ORM_BOOKS";
export const ALGOLIA_AUTHORS_INDEX = process.env.NEXT_PUBLIC_ORM_AUTHORS_INDEX || "ORM_AUTHORS";
const ALGOLIA_POST_INDEX = process.env.NEXT_PUBLIC_ORM_POST_INDEX || "POST";

// Article indices are per site, e.g. "1_POST"
export const getAlgoliaPostIndexName = (siteId) => `${siteId}_${ALGOLIA_POST_INDEX}`;

const POST_INDEX_PATTERN = new RegExp(`^\\d+_${ALGOLIA_POST_INDEX.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}$`);
export const isAlgoliaPostIndex = (indexName) => POST_INDEX_PATTERN.test(indexName || "");

export const getAlgoliaIndexName = (routeName, siteId) => {
  let indexName;
  if (routeName === "books") {
    indexName = ALGOLIA_BOOKS_INDEX;
  }
  if (routeName === "authors") {
    indexName = ALGOLIA_AUTHORS_INDEX;
  }
  if (routeName === "articles") {
    indexName = getAlgoliaPostIndexName(siteId);
  }
  return indexName;
};

const DEFAULT_FREE_SEARCH_TERMS = "free,free ebook,free ebooks,free book,free books,0";

// Lower-cases, drops "$" and collapses extra whitespace so "$0", "Free  Books" and "free books" compare equal.
const normalizeSearchTerm = (term) => term.toLowerCase().replace(/\$/g, "").replace(/\s+/g, " ").trim();

// Comma-separated list from NEXT_PUBLIC_FREE_SEARCH_TERMS (inlined at build time, so it must be read as a
// literal process.env.NEXT_PUBLIC_* reference). Falls back to the default list when unset or empty.
const FREE_SEARCH_TERMS = new Set(
  (process.env.NEXT_PUBLIC_FREE_SEARCH_TERMS || DEFAULT_FREE_SEARCH_TERMS)
    .split(",")
    .map(normalizeSearchTerm)
    .filter(Boolean)
);

// Search terms for which the free results (books priced $0, articles tagged "free") should rank first.
export const isFreeSearchTerm = (searchTerm) => {
  let term = searchTerm || "";
  try {
    term = decodeURIComponent(term);
  } catch {
    // keep the raw term if it is not valid URI encoding
  }
  return FREE_SEARCH_TERMS.has(normalizeSearchTerm(term));
};

///////////////////////////////////////////////////////////////////////////////
//                             URL/LINK FUNCTIONS                            //
///////////////////////////////////////////////////////////////////////////////

export const appendHttpsToUrl = (url) => {
  if (url && typeof url === "string") return url?.indexOf("http") > -1 ? url : `https://${url}`;
};

export const replaceHttpWithHttps = (url) => {
  return url && url.startsWith("http://") ? url.replace("http://", "https://") : url;
};

export const formatUrl = (slug, redirect) => {
  if (redirect) return redirect;
  else {
    if (slug) {
      return slug[0];
    } else return "";
  }
};

export const generateAffiliateLink = (Book, affiliateCode, isOverdriveRequire) => {
  let affiliates = {},
    amazon_url = "",
    { apple_ean, asin, primary_isbn, retailer_site_links } = Book || {}, //Destucture from the coming book object
    { apple, barnes_nobles, barnes_noble_sub, kobo, google } = affiliateCode || {}, //Destructure from coming SiteSetting object
    { amazon } = affiliateCode; //Destructure from coming SiteSetting object

  if (asin) {
    amazon_url = `https://www.amazon.com/dp/${asin}`;
  }
  //E.L temp fix for compensating for marketing services that don't have ASIN's
  if (!asin && retailer_site_links && retailer_site_links.length) {
    const amzLink = retailer_site_links.find((site) => site.name == "Amazon");
    if (amzLink) amazon_url = amzLink.url;
  }

  if (amazon && amazon_url) {
    amazon_url += `?tag=${amazon}`;
  }

  if (amazon_url) {
    affiliates.amazon = {
      name: "Amazon",
      ref: "amazonLink",
      url: amazon_url,
    };
  }

  //Kobo and Barnes & Noble affiliate link
  if (primary_isbn) {
    let urlBarn = "";

    //Barnes & Noble
    if (barnes_nobles && primary_isbn) {
      urlBarn = `http://www.anrdoezrs.net/links/${barnes_nobles}/type/dlg${
        barnes_noble_sub ? `/sid/${barnes_noble_sub}` : ""
      }/https://www.barnesandnoble.com/w?ean=${primary_isbn}`;
    }

    affiliates.barnesNoble = {
      name: "Barnes & Noble",
      ref: "bnLink",
      url: urlBarn,
    };

    // iTunes affiliate link
    let apple_url;

    //RT: Assign apple ean13 or primary_isbn
    if (apple_ean) {
      apple_url = `http://itunes.apple.com/us/book/isbn${apple_ean}`;
    } else {
      apple_url = `http://itunes.apple.com/us/book/isbn${primary_isbn}`;
    }
    //RT: append affliate code if we have it
    if (apple) {
      apple_url += `?ct=${apple}&at=10lrBN`;
    } else {
      apple_url += "?at=10lrBN";
    }

    affiliates.apple = {
      name: "Apple Books",
      ref: "itunesLink",
      url: apple_url,
    };

    //Google affiliate link
    // if (google_id) {
    affiliates.google = {
      name: "Google",
      ref: "googleLink",
      url: `https://play.google.com/store/books/details/?id=ISBN_${primary_isbn}&PAffiliateID=${google}`,
    };
    // }

    if (kobo) {
      affiliates.kobo = {
        name: "Kobo",
        ref: "koboLink",
        url: `https://click.linksynergy.com/deeplink?id=27lTva583xw&mid=37217&u1=${kobo}&murl=https://www.kobo.com/us/en/search?Query=${primary_isbn}`,
      };
    }

    if (isOverdriveRequire && Book.overdriveid) {
      affiliates.overdrive = {
        name: "OverDrive",
        ref: "OverDriveLink",
        url: `https://www.overdrive.com/media/${Book.overdriveid}`,
      };
    }
    return affiliates;
  }
};

// Parse url query parameters into an object
export const parseQueryString = (queryString) => {
  if (!queryString || queryString.indexOf("=") === -1) {
    return false;
  }

  queryString = queryString.substring(queryString.indexOf("?") + 1);

  let i,
    params = {},
    paramsKey,
    paramsValue,
    temp,
    paramsLength,
    queries;

  queries = queryString.split("&");
  paramsLength = queries.length;

  for (i = 0; i < paramsLength; i++) {
    temp = queries[i].split("=");
    paramsKey = temp[0];
    paramsValue = temp[1];
    params[paramsKey] = paramsValue;
  }

  return params;
};

export const getUrlParameters = (url, name) => {
  name = name.replace(/\[/, "\\[").replace(/\]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(url);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export const formatBookDetailUrl = (isbn, slug) => {
  if (isbn && slug) {
    return "/ebook/" + formatSlug(slug) + "/" + isbn;
  }
};

export const formatSlug = (title) => {
  if (title) {
    return slugify(title, {
      lower: true,
      strict: true,
      remove: /[*+~.()'"!:@]/g,
    });
  } else {
    throw "no title was provided to format slug";
  }
};

export const getEnvPrefix = () => {
  const env = process.env.ORION_ENV;
  let linkPrefix;
  if (env === "development") {
    linkPrefix = `http://local.`;
  } else if (env === "staging") {
    linkPrefix = `https://staging.`;
  } else {
    linkPrefix = `https://`;
  }
  return linkPrefix;
};

export const generateBookDetailLink = (primaryIsbn, title) => {
  let link = "";
  let linkPrefix = getEnvPrefix();
  if (primaryIsbn && title) {
    link = linkPrefix + `${findSiteName(6)}${formatBookDetailUrl(primaryIsbn, title)}`;
  }
  return link;
};

export const generateContributorLink = (slug) => {
  let link = "";
  let linkPrefix = getEnvPrefix();
  if (slug) {
    link = linkPrefix + `${findSiteName(6)}/contributor/${formatSlug(slug)}`;
  }
  return link;
};

/**
 * Extracts and normalizes UTM/ORM tracking parameters from a query string.
 * Maps utm_* or orm_* fields to consistent internal keys.
 * https://openroadmedia.atlassian.net/browse/ORMTECH-3268
 * @param {string} queryString - The full query string or URL (e.g., "?utm_source=google&utm_medium=cpc").
 * @returns {Object|null} - Object with normalized keys or null if none found.
 */
export const getUTMParams = (queryString) => {
  if (!queryString || typeof queryString !== "string") return null;

  const query = queryString.includes("?")
    ? queryString.substring(queryString.indexOf("?") + 1)
    : queryString;

  const params = new URLSearchParams(query);
  const utmParams = {};

  // Mapping of querystring keys to normalized output keys
  const keyMap = {
    utm_source: "referral_source",
    orm_source: "referral_source",
    utm_campaign: "campaign",
    orm_campaign: "campaign",
    utm_content: "content",
    orm_content: "content",
    utm_medium: "medium",
    orm_medium: "medium",
    utm_term: "term",
    orm_term: "term",
    utm_referrer: "referrer",
    orm_referrer: "referrer",
    gclid: "gclid",
    gkeyword: "gkeyword",
  };

  for (const [queryKey, outputKey] of Object.entries(keyMap)) {
    // Do not overwrite if already populated (prefer utm_ over orm_)
    if (!utmParams[outputKey] && params.has(queryKey)) {
      utmParams[outputKey] = params.get(queryKey);
    }
  }

  return Object.keys(utmParams).length > 0 ? utmParams : null;
};

export const amazonAsinParser = (amazonLink) => {
  if (amazonLink) {
    let regex =
      /https?:\/\/(www\.)?(.*)amazon\.([a-z.]{2,6})(\/d\/(.*)|\/(.*)\/?(?:dp|o|gp|-)\/)(aw\/d\/|product\/)?(B[0-9]{1}[0-9A-Z]{8}|[0-9]{9}(?:X|[0-9]))/i;
    if (amazonLink?.match(regex)) {
      return amazonLink?.match(regex)?.splice(-1)[0];
    }
  }
};

export const generateAmazonBookPreviewLink = (amazonLink, previewAffiliateCode) => {
  //In case if preview affiliate code is null, set it to ebb at least to get affiliate revenue
  if (!previewAffiliateCode) {
    previewAffiliateCode = "ebbsitepreview-20";
  }

  let asin = amazonAsinParser(amazonLink) || "";
  const tag = previewAffiliateCode;

  if (asin) {
    return `https://read.amazon.com/kp/card?asin=${asin}&tag=${tag}`;
  }
  return null;
};

export const parseUserAgent = (userAgent) => {
  let isMobileView, isTabletView;
  if (userAgent) {
    // Mobile detection
    isMobileView = userAgent.match(
      /BlackBerry|iPhone|Opera Mini|IEMobile|WPDesktop|(android(.*mobile))/i
    );

    // Enhanced tablet detection including all iPad models
    isTabletView =
      userAgent.match(
        /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i
      ) ||
      // Check for iPad Pro and newer iPads that report as Macintosh
      (/Macintosh/.test(userAgent) &&
        // Check for iPad-specific features in user agent
        (/iPad/.test(userAgent) ||
          /iPad Pro/.test(userAgent) ||
          /iPad Air/.test(userAgent) ||
          /iPad mini/.test(userAgent) ||
          // Check for iPad touch capabilities (client-side only)
          (typeof document !== "undefined" && "ontouchend" in document) ||
          // Check for iPad-specific platform identifiers
          (typeof navigator !== "undefined" &&
            navigator.platform &&
            navigator.platform.indexOf("iPad") !== -1) ||
          // Check for iPad screen dimensions and touch capabilities (client-side only)
          (typeof window !== "undefined" &&
            window.screen &&
            window.screen.width >= 768 &&
            window.screen.height >= 1024 &&
            typeof document !== "undefined" &&
            "ontouchend" in document)));
  }

  return {
    isMobile: !!isMobileView,
    isTablet: !!isTabletView,
  };
};

// Enhanced client-side tablet detection for better iPad support
export const enhanceTabletDetection = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return null;
  }

  // Additional iPad detection methods that work on the client side
  const isIPad =
    // Check for iPad-specific platform
    (navigator.platform && navigator.platform.indexOf("iPad") !== -1) ||
    // Check for iPad touch points
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 1) ||
    // Check for iPad screen dimensions and touch capabilities
    (window.screen &&
      window.screen.width >= 768 &&
      window.screen.height >= 1024 &&
      "ontouchend" in document) ||
    // Check for iPad-specific CSS media queries
    (window.matchMedia && window.matchMedia("(hover: none) and (pointer: coarse)").matches);

  return {
    isEnhancedTablet: isIPad,
    screenWidth: window.screen?.width,
    screenHeight: window.screen?.height,
    maxTouchPoints: navigator.maxTouchPoints,
    platform: navigator.platform,
    userAgent: navigator.userAgent,
  };
};

export const newGetURLData = (requestedHost, asPath) => {
  // Determine the host based on client or server context
  let host = Browser.isClient() ? Browser.getHost() : requestedHost;
  host = appendHttpsToUrl(host);
  // Validate that both host and asPath are available
  if (host && asPath) {
    try {
      let pageUrl = host + asPath,
        siteId = findSiteId(host),
        pageNumber = getPageNumber(asPath),
        pathArray = asPath
          .replace(/\/$/, "") // Remove trailing slash
          .toString()
          .replace("/", "")
          .split("/"),
        pageName = pathArray[0],
        slugPage = pathArray.pop(),
        slug = slugPage.split("?")[0],
        originalSlug = new URL(pageUrl).pathname;

      return {
        pageUrl,
        pageNumber,
        slug,
        pageName,
        host,
        siteId,
        originalSlug,
      };
    } catch (error) {
      console.error("Error in newGetURLData:", error);
      // Return default values if an error occurs
      return {
        pageUrl: "",
        pageNumber: null,
        slug: "",
        pageName: "",
        host: host || "",
        siteId: host ? findSiteId(host) ?? null : null,
        originalSlug: "",
      };
    }
  }

  // Return default values if host or asPath is missing; still resolve siteId from host when possible
  return {
    pageUrl: "",
    pageNumber: null,
    slug: "",
    pageName: "",
    host: host || "",
    siteId: host ? findSiteId(host) ?? null : null,
    originalSlug: "",
  };
};

export const getURLData = (req, asPath) => {
  let host = Browser.isClient() ? Browser.getHost() : req.headers.host;
  host = appendHttpsToUrl(host);
  let pageUrl = host + asPath,
    siteId = findSiteId(host),
    pageNumber = getPageNumber(asPath),
    pathArray = asPath.replace(/\/$/, "").toString().replace("/", "").split("/"),
    pageName = pathArray[0],
    slugPage = pathArray.pop(),
    slug = slugPage.split("?")[0],
    originalSlug = new URL(pageUrl).pathname;
  return {
    pageUrl,
    pageNumber,
    slug,
    pageName,
    host,
    siteId,
    originalSlug,
  };
};

export const getCanonicalUrl = (currentUrl) => {
  let canonicalUrl = currentUrl;
  if (canonicalUrl && canonicalUrl.indexOf("?") > 0) {
    let pathArray = currentUrl.toString().split("?");
    canonicalUrl = pathArray[0];
  }
  return appendHttpsToUrl(canonicalUrl);
};

export const redirectHandler = (appContext, redirectURL) => {
  if (redirectURL === "login") {
    if (typeof window === "undefined") {
      RouteService.redirect("login", "/login");
    } else {
      appContext.res.writeHead(302, { Location: "/login" });
      appContext.res.end();
    }
  } else {
    if (typeof window === "undefined") {
      RouteService.redirect("ebook", redirectURL);
    } else {
      appContext.res.writeHead(301, { Location: redirectURL });
      appContext.res.end();
    }
  }
};

export const newRedirectHandler = (redirectURL) => {
  if (redirectURL === "login") {
    if (typeof window === "undefined") {
      RouteService.redirect("login", "/login");
    } else {
      const response = new Response("", {
        status: 302,
        headers: { Location: "/login" },
      });
      return response;
    }
  } else {
    if (typeof window === "undefined") {
      RouteService.redirect("ebook", redirectURL);
    } else {
      const response = new Response("", {
        status: 301,
        headers: { Location: redirectURL },
      });
      return response;
    }
  }
};

///////////////////////////////////////////////////////////////////////////////
//                           GENERIC/UTIL FUNCTIONS                          //
///////////////////////////////////////////////////////////////////////////////

export const isSubset = (target, sample) => {
  return target.every((i) => sample.includes(i));
};

export const mapToDBValue = (str) => {
  return str
    .replace(/[^a-zA-Z- ]/g, "")
    .split(/[ -]+/)
    .filter((i) => i)
    .join("_")
    .toLowerCase();
};

export const _capitalizeFirstLetter = (string) => {
  if (string) {
    if (string.constructor === String) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else if (string.constructor === Array) {
      let strArray = [];
      for (let i = 0; i < string.length; i++) {
        if (string[i] === String) {
          strArray.push(string[i].charAt(0).toUpperCase() + string[i].slice(1));
        }
      }
      return strArray;
    }
  }
};

export const _formatIfArray = (value) => {
  if (Array.isArray(value) && value.length > 1) {
    let result = "";
    for (let i = 0; i < value.length; i++) {
      if (i == 0) result += value[i];
      else result += ", " + value[i];
    }
    return result;
  } else return value ? value.toString() : value;
};

export const startCase = (str) => {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
};

export const getSubstring = (title, allowLength) => {
  if (title && title.length > allowLength) {
    title = title.substr(0, allowLength) + " ...";
  }
  return title;
};

export const _formatArray = (arr, all, last) => {
  if (typeof arr != "object") {
    return arr;
  }

  // Check if arr is truly an array and has length
  if (!Array.isArray(arr) || !arr.length) {
    return arr;
  }

  // If arr contains only one item, return it directly
  if (arr.length === 1) {
    return arr[0];
  }

  // Clone the array to avoid modifying the original
  let clonedArr = arr.slice();
  // Extract the last item
  let lastItem = clonedArr.splice(-1)[0];
  // Join the remaining items
  let initialPart = clonedArr.length ? clonedArr.join(all) : "";
  // Return the formatted string
  return [initialPart, lastItem].join(arr.length > 2 ? last : all);
};

export const deepEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true;

  if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 === null || obj2 === null) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  return keys1.every((key) => deepEqual(obj1[key], obj2[key]));
};

export const getRecommendedBooks = (books, bookCount) => {
  if (books && books.length > 0) {
    let uniqueAuthors = [],
      found;
    books.forEach((book) => {
      const price = parseFloat(book.price);
      if (price >= 3.99 && price <= 17.99) {
        if (uniqueAuthors.length > 0) {
          found = uniqueAuthors.find(
            (item) => item.authors[0].firebrand_id === book.authors[0].firebrand_id
          );
          if (!found) {
            uniqueAuthors.push(book);
          }
        } else {
          uniqueAuthors.push(book);
        }
      }
    });
    return uniqueAuthors.sort(() => Math.random() - Math.random()).slice(1, bookCount);
  } else {
    return [];
  }
};

export const fireGoogleTags = () => {
  //Adding custom event to Google Tag Manager to fire tags again
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({ event: "FireAllPageLoadTagAgainOnPagination" });
  }
};

/*
  formatDescription function is used to format the description according to the length and description value, this will check if description is blank then it will use title as description 
  @parameters:
  title : Page title to use as meta description if description is blank
  description : Page description to use as meta description
  allowLength : To identify how many chars are allow according to the facebook and twitter, so it used to break the description if length exceeded.
*/
export const formatDescription = (title, description, allowLength) => {
  let formattedDescription = description;
  if (formattedDescription) {
    if (formattedDescription.length > allowLength) {
      formattedDescription = formattedDescription.substr(0, allowLength);
    }
  } else {
    formattedDescription = title;
  }
  return formattedDescription;
};

/* 
  renderNextLink is use to render the next link in the meta inside the <head> tag only if :
  - pagination is on the page
  - If the current page is not the last page

*/
export const renderNextLink = (link, isLastPage, domain) => {
  if (link) return !isLastPage && { rel: "next", href: appendHttpsToUrl(`${domain}${link}`) };
};

/* 
renderPreviousLink is use to render the prev link in the meta inside the <head> tag only if :
- pagination is on the page
- If the current page is not the first page
*/
export const renderPreviousLink = (link, isFirstPage, domain) => {
  if (link)
    return (
      !isFirstPage && {
        rel: "prev",
        href: appendHttpsToUrl(`${domain}${link}`),
      }
    );
};

export const getOptInNewsletterCopy = (siteId) => {
  let siteName =
    siteId === Sites.OPENROADMEDIA || siteId === Sites.EARLYBIRDBOOKS
      ? "The Reader"
      : "Early Bird Books";
  return `Yes! I also want to get ${siteName} newsletter featuring book deals, recommendations, and giveaways.`;
};

export const getOptInNewsletter = (siteId) => {
  return siteId === Sites.OPENROADMEDIA || siteId === Sites.EARLYBIRDBOOKS
    ? "ebbreader"
    : findSiteNameWithoutCom(Sites.EARLYBIRDBOOKS);
};

export const getPrimaryNewsletter = (siteId) => {
  return siteId === Sites.OPENROADMEDIA
    ? findSiteNameWithoutCom(Sites.EARLYBIRDBOOKS)
    : findSiteNameWithoutCom(siteId);
};

/* This function is used to truncate text upto certain number of characters
  @params
    str  - string to shorten
    n - number of characters upto which string is truncated,
            if no length is provided, string is not truncated
    end  - optional string to add at end of truncated text
  */
export const shorten = (str, n, end) => {
  if (!str) {
    return "";
  }
  if (!n) {
    n = str.length;
  }
  if (!end) {
    end = "";
  }

  let short = (str.match(RegExp(".{" + n + "}\\S*")) || [str])[0];
  return short + end;
};

/*
  modalClickFunction function used for google analytic of follow author button click,
  calling this function after successfull form submission.
*/
export const modalClickFunction = (authorName, eventName, titleISBN) => {
  if (Browser.isClient() && typeof window !== "undefined") {
    let data = {
      authorName: `${authorName}`,
      event: `${eventName}`,
    };
    if (titleISBN) {
      data.titleISBN = `${titleISBN}`;
    }
    window.dataLayer.push(data);
  }
};

export const getAllImageURL = (name) => {
  let cdn = "https://orion-uploads.openroadmedia.com/";
  let images = [];
  images.push(`"${cdn}xl_${name}"`);
  images.push(`"${cdn}lg_${name}"`);
  images.push(`"${cdn}md_${name}"`);
  images.push(`"${cdn}sm_${name}"`);
  return images;
};

export const getSiteName = (siteId) => {
  let siteName = findSiteNameWithoutCom(siteId);
  let siteTitle = Sites.NEWSLETTERS.find((newsletter) => {
    if (newsletter.NEWSLETTER_KEY == siteName) {
      return newsletter.NAME;
    }
  });
  return siteTitle.NAME;
};

export const slugRegexMatcher = (slug, disallowed) => {
  if (slug === "/") return false;
  const regTerm = new RegExp(`/${disallowed}(.*)`, "ig");
  return regTerm.test(slug);
};

export const removeHtmlTag = (str) => {
  if (str) {
    let string = str.replace(/<[^>]*>/g, "");
    return string;
  }
};

export const buildNewsletterSignupObject = (propObj) => {
  let { siteId } = propObj;
  let params = {};
  params.newsletters = [
    {
      name: _SITEID_REVERSE_MAP_.get(siteId),
      shouldSendEmail: false,
      userOptionalParams: this.populateSailthruUserVars(this.props.primaryNewsletter),
    },
  ];
};

export const isIPadProOnSafari = (userAgent) => {
  // Use the passed userAgent if provided, otherwise fallback to the client-side navigator (if available)
  const agent = userAgent || (typeof navigator !== "undefined" ? navigator.userAgent : "");

  //to detect IPadPro device
  return /Macintosh/.test(agent) && typeof document !== "undefined" && "ontouchend" in document;
};

/* Used for building keys for fuse search on deals page */
export const keyIfy = (obj, prefix = "") =>
  Object.keys(obj).reduce((res, el) => {
    if (Array.isArray(obj[el])) {
      if (el === "authors") {
        return [...res, ...keyIfy(obj[el], prefix + el + ".")];
      }
      return res;
    } else if (typeof obj[el] === "object" && obj[el] !== null) {
      if (prefix.split(".").slice(-2)[0] === "authors") {
        return [...res, ...keyIfy(obj[el], prefix)];
      }
      return [...res, ...keyIfy(obj[el], prefix + el + ".")];
    } else if (el === "title") {
      return [...res, { name: prefix + el, weight: 2 }];
    }
    return [...res, prefix + el];
  }, []);

// export function debounce(func, wait) {
//   let timeout;
//   return function (...args) {
//     const context = this;
//     if (timeout) clearTimeout(timeout);
//     timeout = setTimeout(() => {
//       timeout = null;
//       func.apply(context, args);
//     }, wait);
//   };
// }

export const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

export const buildRetailers = (props) => {
  const shouldShowBookshop = process.env.SHOW_BOOKSHOP === "true";

  let retailers = [
    {
      display: "Amazon",
      kmName: "Amazon",
      Name: "Amazon",
      url: props.amazonLink || "",
      backgroundImage: `${process.env.S3_IMAGE_URL}/retailer-button/Amazon.png`,
      alt_text: "Buy at Amazon",
    },
    {
      Name: "Apple",
      display: "Apple Books",
      kmName: "iTunes",
      url: props.itunesLink,
      backgroundImage: `${process.env.S3_IMAGE_URL}/retailer-button/Apple.png`,
      alt_text: "Buy at Apple Books",
    },
    {
      Name: "BN",
      display: "Barnes & Noble",
      kmName: "Barnes&Noble",
      url: props.bnLink,
      backgroundImage: `${process.env.S3_IMAGE_URL}/retailer-button/BN.png`,
      alt_text: "Buy at Barnes and Noble",
    },
  ];

  // Only add Bookshop if enabled
  if (shouldShowBookshop) {
    retailers.push({
      Name: "BookShop",
      display: "Bookshop.org",
      kmName: "BookShop",
      url: props.bookShopLink || props.bookshopLink,
      backgroundImage: `${process.env.S3_IMAGE_URL}/retailer-button/bookshop.png`,
      alt_text: "Buy at Bookshop.org",
    });
  }

  // Add remaining retailers
  retailers.push(
    {
      Name: "Google",
      display: "Google",
      kmName: "Google",
      url: props.googleLink,
      backgroundImage: `${process.env.S3_IMAGE_URL}/retailer-button/Google.png`,
      alt_text: "Buy at Google",
    },
    {
      Name: "Kobo",
      display: "Kobo",
      kmName: "Kobo",
      url: props.koboLink,
      backgroundImage: `${process.env.S3_IMAGE_URL}/retailer-button/Kobo.png`,
      alt_text: "Buy at Kobo",
    }
  );

  if (props.customretailername && props.customretailerurl) {
    retailers.push({
      customretailername: props.customretailername,
      display: props.customretailername,
      kmName: "Cutom Retailer",
      Name: "Cutom Retailer",
      url: props.customretailerurl,
      alt_text: props.customretailername,
    });
  }
  return retailers;
};

export const getStoredLiDid = () => {
  if (typeof window === "undefined") return "";
  try {
    const stored = localStorage.getItem("li_did");
    if (stored) {
      const parsed = JSON.parse(stored);
      const value = parsed?.value;
      const expires = parsed?.expires;
      if (value && expires && new Date().getTime() < expires) return value;
      if (expires && new Date().getTime() >= expires) {
        localStorage.removeItem("li_did");
      }
    }
  } catch {
    // ignore parse errors
  }
  try {
    const fromUrl = new URLSearchParams(window.location.search).get("li_did");
    if (fromUrl) return fromUrl;
  } catch {
    // ignore
  }
  return "";
};

const generateEventId = () => {
  if (typeof globalThis.crypto?.randomUUID === "function") {
    return globalThis.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

export const sendLiveIntentRetailClickBeacon = (gaPayload) => {
  if (typeof window === "undefined" || !process.env.APICLOUDFRONTURL) return;

  const liDid = getStoredLiDid();
  const body = JSON.stringify({
    eventId: generateEventId(),
    eventTime: Math.floor(Date.now() / 1000),
    sourceUrl: window.location.href,
    eventAction: gaPayload.eventAction,
    eventCategory: gaPayload.eventCategory,
    eventLabel: gaPayload.eventLabel,
    li_did: liDid,
    email: readCookie("subscribed") || "",
  });

  const url = `${process.env.APICLOUDFRONTURL}/liveintent/retail-click`;

  try {
    // fetch + keepalive is more reliable than sendBeacon for JSON body parsing on the API
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    });
  } catch {
    // non-blocking; GTM tracking should not be affected
  }
};

// GTM dataLayer shape is relied on by existing tags — do not change event/eventLabel format here.
export const fireGTMEvent = (
  eventCategory,
  title,
  primary_isbn,
  isbns,
  publisher,
  isMarketingServices,
  kmName,
  gaName
) => {
  const gaPayload = {
    eventCategory,
    eventLabel: `${title} | ${primary_isbn || isbns} | ${publisher}`,
    eventAction: `Retail Click, ${gaName}`,
  };
  if (typeof window != "undefined") {
    if (primary_isbn || (isbns && isbns.length > 0)) {
      //ga('orim180.send', 'event', gaPayload);
      window.dataLayer.push({ event: gaPayload.eventAction, ...gaPayload });
      sendLiveIntentRetailClickBeacon(gaPayload);
    }
  }
};

export const getEnvironment = (host) => {
  let env = "https://";
  if (host.indexOf("local") !== -1) {
    env = "http://local.";
  }

  if (host.indexOf("staging") !== -1) {
    env = "https://staging.";
  }

  return env;
};

export const lowerCaseUnderscoreString = (string) => {
  let result = string;
  if (string) {
    result = result
      .trim()
      .toLowerCase()
      .replace(`'`, "")
      .replace(/[^a-zA-Z]/g, " ")
      .replace(/ +/g, "_");
  }
  return result;
};

export const addTimeInMinutes = (mins = 15) => {
  // Get the current date and time
  const currentDate = new Date();

  // Add one hour to the current date and time
  const newDate = addMinutes(currentDate, mins);

  // Format the resulting date into the desired format
  const formattedDate = format(newDate, "yyyy-MM-dd HH:mm:ss");
  return formattedDate;
};

export const _SITEID_SITE_NAME_MAP_ = (siteId) => {
  const siteID_site_name_map = new Map([
    [Sites.EARLYBIRDBOOKS, "Early Bird Books"],
    [Sites.THE_LINE_UP, "The Lineup"],
    [Sites.THEPORTALIST, "The Portalist"],
    [Sites.OPENROADMEDIA, "Open Road Media"],
    [Sites.MURDER_MAYHEM, "Murder & Mayhem"],
    [Sites.ALOVESOTRUE, "A Love So True"],
    [Sites.EXPLORETHEARCHIVE, "Explore The Archive"],
  ]);
  return siteID_site_name_map.get(siteId);
};

export const SiteColors = (siteId) => {
  const textcolor_siteid_map = new Map([
    [Sites.EARLYBIRDBOOKS, "#2C68B0"],
    [Sites.THE_LINE_UP, "#8A0509"],
    [Sites.THEPORTALIST, "#3C7D9A"],
    [Sites.MURDER_MAYHEM, "#F2DE22"],
    [Sites.EXPLORETHEARCHIVE, "#C7B299"],
    [Sites.ALOVESOTRUE, "#E35866"],
  ]);
  return textcolor_siteid_map.get(siteId);
};

export const validateEmailFormat = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const isFutureDate = (dateString) => {
  if (dateString) {
    // Create a Date object from the given date string
    const inputDate = new Date(dateString);

    // Get the current date
    const currentDate = new Date();

    // Set the time of the current date to midnight to only compare dates, not times
    currentDate.setHours(0, 0, 0, 0);

    // Check if the input date is greater than the current date
    return inputDate > currentDate;
  } else {
    return false;
  }
};

//// data => page specific data
export const checkForNonClosableModal = (isMobile, data) => {
  let isNonClosableModalChecked =
    isMobile &&
    data?.length > 0 &&
    data[0]?.Post?.post?.components?.length > 0 &&
    data[0]?.Post?.post?.components.filter((el) => {
      if (el && el?.type === "newsletter") {
        return el.props.nonClosableModalProps;
      }
      if (el && el?.type === "newsletter-v2") {
        return el.props.modalProps.nonClosableModal;
      }
    });

  isNonClosableModalChecked = isNonClosableModalChecked?.length > 0 || false;

  return isNonClosableModalChecked;
};

export const decodeHtmlEntities = (text) => {
  if (typeof text === "string") {
    return decode(text);
  }
  return ""; // always return a string
};

/**
 * Converts a given object into a URL query string.
 *
 * Rules:
 * - Skips keys where the value is `undefined`, `null`, an empty string, or an empty array.
 * - For array values, repeats the key for each item (e.g., genres=fiction&genres=history).
 * - All keys and values are URL-encoded to ensure special characters are safely included.
 *
 * @param {Object} data - The object to convert into a query string.
 * @returns {string} The encoded query string without the leading "?".
 */
export const convertToQueryString = (data) => {
  const queryString = Object.entries(data)
    .filter(([, value]) => {
      if (value === undefined || value === null) return false;
      if (Array.isArray(value) && value.length === 0) return false;
      if (typeof value === "string" && value.trim() === "") return false;
      return true;
    })
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        // ✅ join array items with comma
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.join(","))}`;
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .join("&");

  return queryString;
};

export const toTitleCaseAdvanced = (str) => {
  // First, handle apostrophes by temporarily replacing them
  const tempStr = str.toLowerCase().replace(/'/g, "___APOSTROPHE___");

  // Apply title case
  const titleCaseStr = tempStr.replace(/\b\w/g, (char) => char.toUpperCase());

  // Restore apostrophes and ensure letters after apostrophes are lowercase
  return titleCaseStr
    .replace(/___APOSTROPHE___/g, "'")
    .replace(/'[A-Z]/g, (match) => match.toLowerCase());
};

///////////////////////////////////////////////////////////////////////////////
//                           FLOATING MENU FUNCTIONS                         //
///////////////////////////////////////////////////////////////////////////////

/**
 * Checks if the floating menu should be hidden for a given post type on mobile/tablet devices
 * @param {number} postType - The post type number (e.g., 12 for DEALS)
 * @param {boolean} isMobile - Whether the device is mobile
 * @param {boolean} isTablet - Whether the device is tablet
 * @returns {boolean} - True if floating menu should be hidden, false otherwise
 */
export const shouldHideFloatingMenu = (postType, isMobile, isTablet) => {
  // Only hide on mobile and tablet devices
  if (!isMobile && !isTablet) {
    return false;
  }

  // Get restricted post types from environment variable
  const restrictedPostTypes = process.env.FLOATING_MENU_RESTRICTED_POST_TYPES;

  if (!restrictedPostTypes) {
    return false;
  }

  // Parse the comma-separated list of restricted post types
  const restrictedTypes = restrictedPostTypes
    .split(",")
    .map((type) => parseInt(type.trim(), 10))
    .filter((type) => !isNaN(type));

  // Check if current post type is in the restricted list
  return restrictedTypes.includes(postType);
};

/**
 * Checks if floating menu should be shown based on post type and device
 * @param {number} postType - The post type number
 * @param {boolean} isMobile - Whether the device is mobile
 * @param {boolean} isTablet - Whether the device is tablet
 * @returns {boolean} - True if floating menu should be shown, false otherwise
 */
export const shouldShowFloatingMenu = (postType, isMobile, isTablet) => {
  return !shouldHideFloatingMenu(postType, isMobile, isTablet);
};

export const formatPrice = (value) => {
  if (value === null || value === undefined) return value;

  // If the input is a number
  if (typeof value === "number") {
    return `$${value.toFixed(2)}`;
  }

  // If the input is a string
  if (typeof value === "string") {
    // Check if the original string had a "$" symbol
    const hadDollarSign = value.trim().startsWith("$");

    // Trim and remove leading "$"
    const cleaned = value.trim().replace(/^\$/, "");

    // Convert to number
    const num = Number(cleaned);

    // If not a valid number, return original
    if (isNaN(num)) return value;

    // Return formatted number with "$" if it was present in the original
    return hadDollarSign ? `$${num.toFixed(2)}` : num.toFixed(2);
  }

  // If some other type (object, boolean, etc.)
  return value;
};
